import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_WEBHOOKS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Webhook from "./Webhook";
import WebhookList from "./WebhookList";

export default function Webhooks() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_WEBHOOKS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/settings/webhooks/new`));

  return <MasterDetail identifier="id" master={<WebhookList />} detail={<Webhook />} />;
}
